import { createSelector } from '@reduxjs/toolkit';
import { WorkflowDisplayMode, WorkflowTaskDetailType } from '@vision/ui/enums';
import { RootState } from '@vision/ui/store';

export const addWorkflowModalSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ managingWorkflow, addWorkflowModalOpened, displayMode, isDirty }) => ({
    addWorkflowModalOpened,
    managingWorkflow,
    editing: displayMode === WorkflowDisplayMode.EDIT,
    isDirty,
    previewing: displayMode === WorkflowDisplayMode.PREVIEW,
  }),
);

export const addConditionPanelSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ addConditionPanelOpened, managingWorkflow, editingCondition }) => ({
    opened: addConditionPanelOpened,
    workflow: managingWorkflow,
    editingCondition,
  }),
);

export const addFilterPanelSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ addFilterPanelOpened, editingFilter }) => ({
    opened: addFilterPanelOpened,
    editingFilter,
  }),
);

export const addTaskPanelSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ addTaskPanelOpened, currentNode, editingTask, taskValidationRequestedKey }) => ({
    addingBranchIfFilter: editingTask?.action.detail_type === WorkflowTaskDetailType.BRANCH_IF && currentNode !== null,
    opened: addTaskPanelOpened,
    editingTask,
    taskValidationRequestedKey,
  }),
);

export const workflowEditorSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ managingWorkflow, addConditionPanelOpened, addFilterPanelOpened, addTaskPanelOpened, displayMode, isDirty }) => ({
    addConditionPanelOpened,
    addFilterPanelOpened,
    addTaskPanelOpened,
    editing: displayMode === WorkflowDisplayMode.EDIT,
    cloning: displayMode === WorkflowDisplayMode.CLONE,
    isDirty,
    managingWorkflow,
  }),
);

export const managingWorkflowSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ managingWorkflow, displayMode }) => ({
    managingWorkflow,
    cloning: displayMode === WorkflowDisplayMode.CLONE,
    previewing: displayMode === WorkflowDisplayMode.PREVIEW,
    editing: displayMode === WorkflowDisplayMode.EDIT,
  }),
);

export const managingWorkflowAndEditingTaskSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ managingWorkflow, editingTask }) => ({
    managingWorkflow,
    editingTask,
  }),
);

export const workflowDisplayModeSelector = createSelector(
  (state: RootState) => state.WorkflowsState,
  ({ displayMode }) => ({
    displayMode,
    cloning: displayMode === WorkflowDisplayMode.CLONE,
    editing: displayMode === WorkflowDisplayMode.EDIT,
    previewing: displayMode === WorkflowDisplayMode.PREVIEW,
  }),
);

export const defaultTaskParametersSelector = (state: RootState) => state.WorkflowsState.defaultTaskParameters;

export const editingTaskSelector = (state: RootState) => state.WorkflowsState.editingTask;

export const workflowIsDirtySelector = (state: RootState) => state.WorkflowsState.isDirty;
